import { useAuth } from '../context/AuthContext';
import { Menu, LogOut, Bell, ChevronDown } from 'lucide-react';
import { Dropdown } from './Dropdown';

interface TopbarProps {
  onToggleSidebar: () => void;
  sidebarCollapsed: boolean;
}

export function Topbar({ onToggleSidebar, sidebarCollapsed }: TopbarProps) {
  const { user, signOut } = useAuth();

  return (
    <header className="topbar" role="banner">
      <div className="topbar-left">
        <button
          className="sidebar-toggle"
          onClick={onToggleSidebar}
          aria-label={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          aria-expanded={!sidebarCollapsed}
        >
          <Menu size={20} />
        </button>
      </div>

      <div className="topbar-right">
        {/* Notifications */}
        <div className="dropdown">
          <button
            className="btn btn-ghost btn-icon tooltip"
            data-tooltip="Notifications"
            aria-label="Notifications"
          >
            <Bell size={20} />
          </button>
        </div>

        {/* User Menu */}
        <Dropdown
          trigger={({ onClick, open }) => (
            <button
              className="btn btn-ghost"
              aria-label="User menu"
              aria-expanded={open}
              aria-haspopup="true"
              onClick={onClick}
            >
              <div style={{
                width: 32,
                height: 32,
                borderRadius: 'var(--radius-pill)',
                background: 'var(--gradient-primary)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontWeight: 700,
                fontSize: 'var(--text-sm)',
              }}>
                {user?.username?.[0]?.toUpperCase() || 'U'}
              </div>
              <ChevronDown size={16} />
            </button>
          )}
        >
          {(close) => (
            <div role="menu">
              <div style={{ padding: 'var(--space-2) var(--space-3)', borderBottom: '1px solid var(--surface-border)' }}>
                <div style={{ fontWeight: 600, fontSize: 'var(--text-sm)', color: 'var(--slate-900)' }}>
                  {user?.email || user?.username || 'User'}
                </div>
                <div style={{ fontSize: 'var(--text-xs)', color: 'var(--slate-500)' }}>
                  Admin
                </div>
              </div>
              <button className="dropdown-item" role="menuitem" onClick={() => { close(); signOut(); }}>
                <LogOut size={16} />
                Sign out
              </button>
            </div>
          )}
        </Dropdown>
      </div>
    </header>
  );
}